import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton, Paper, Slide, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChatIcon from '@mui/icons-material/Chat';
import { dismissChatArrival, requestOpenLiveChat, useChatAlerts } from '../../services/ecommerceChatAlerts';

/** Yeni canlı destek mesajında sağ üstte (zilin altında) çıkan kısa uyarı. 12 sn sonra kendiliğinden kapanır. */
const EcommerceChatToast: React.FC = () => {
  const { arrival } = useChatAlerts();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!arrival) {
      setOpen(false);
      return;
    }
    setOpen(true);
    const t = window.setTimeout(() => setOpen(false), 12000);
    return () => window.clearTimeout(t);
  }, [arrival]);

  if (!arrival) return null;

  const close = () => {
    setOpen(false);
    dismissChatArrival();
  };

  return (
    <Slide direction="left" in={open} mountOnEnter unmountOnExit>
      <Paper
        elevation={10}
        sx={{
          position: 'fixed',
          top: 72,
          right: { xs: 8, sm: 24 },
          left: { xs: 8, sm: 'auto' },
          zIndex: 1500,
          width: { sm: 340 },
          overflow: 'hidden',
          borderRadius: 2,
          borderLeft: '4px solid',
          // Aquasoft kurumsal renkleri (tema paleti: primary #0D47A1, secondary #1976D2, info/accent #42A5F5)
          borderLeftColor: 'info.main',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 1.5,
            py: 1,
            background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
            color: '#fff',
          }}
        >
          <ChatIcon fontSize="small" />
          <Typography variant="subtitle2" sx={{ flex: 1 }}>{arrival.title}</Typography>
          <IconButton size="small" onClick={close} sx={{ color: '#fff' }} aria-label="Kapat">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box sx={{ p: 1.5, display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Typography variant="body2" sx={{ flex: 1 }}>{arrival.body}</Typography>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              close();
              requestOpenLiveChat(arrival.sessionId);
            }}
            sx={{ flexShrink: 0, textTransform: 'none' }}
          >
            Yanıtla
          </Button>
        </Box>
      </Paper>
    </Slide>
  );
};

export default EcommerceChatToast;
